import React, { useState, useCallback } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import BillingList from '../Billing';

import './index.css'
import { GiMoneyStack } from 'react-icons/gi';

function FinancialTabs({ billings, BankAccounts}) {
  const [key, setKey] = useState('billing');

  const controlTab = useCallback((key) => {
    setKey(key)
  }, [])

  return (
    <Tabs
      id="controlled-tab"
      activeKey={key}
      onSelect={(k) => controlTab(k)}
      className="Tabs-financial"
    >
      <Tab eventKey="billing" title={
        <AnchorLink href="#billings">
          <span className="tabs-title"> Faturas
            <GiMoneyStack style={{ marginLeft: '1rem' }} />
          </span>
        </AnchorLink>
      }>
        <div className="data-table-container">
          <BillingList data={billings} />
        </div>
      </Tab>
      {/* <Tab eventKey="bankAcc" title={
        <AnchorLink href="#billings">
          <span className="tabs-title"> Contas Bancárias
            <AiTwotoneBank style={{ marginLeft: '1rem' }} />
          </span>
        </AnchorLink>
      }>
        <div className="data-table-container" >
        <BankAccountsList data={BankAccounts}/>
        </div>
      </Tab> */}
    </Tabs>
  );
}

export default FinancialTabs;